import { useEffect, useState } from "react";
import classnames from "classnames";
import classes from "../../styles/Subscription.module.scss";
import Header from "../../components/common/Header/Header";
import Footer from "../../components/common/Footer/Footer";
import useIsMobile from "../../components/hooks/useIsMobile";
import StandardFeatures from "./components/StandardFeatures";
import PackageCard from "./components/PackageCard";
import { prepaidPackages } from "../../global/constant";
import CustomEnterprisePlan from "./components/CustomEnterprisePlan";
import { PLAN_URL } from "../../config";

function SubscriptionPage() {
  const isMobile = useIsMobile({ breakpoint: 768 });
  const [tab, setTab] = useState("prepaid");
  const [planList,setPlanList]=useState([])

  const getPrepaidPlans=async()=>{
    await fetch(`${PLAN_URL}/v1/public-api/get-standard-plans?pageNumber=0`, {
      method: "GET",
      headers: {
        "Content-Type": `application/json`,
      },
    }).then((response) => response.json()
     ).then((data) => {
        const localData=data.data.data
        // console.log(localData,prepaidPackages);
        // let localPlans=[...prepaidPackages]
        let finalPlans=[]
        prepaidPackages.forEach((obj,index)=>{
          // console.log(obj)
          const localuserslimit=obj.userslimit.replace('<agentcount>',`${localData[index].agentCount} users`)
          const localfeatures=obj.features.map((f,i)=>{
            if(f.includes('<storage>')){
              return f.replace('<storage>',`${localData[index].storageGBs}`)
            }else if(f.includes('<workflow>')){
              return f.replace('<workflow>',`${localData[index].workflowAutomation?'available':'not available'}`)
            }else if(f.includes('<agentchat>')){
              return f.replace('<agentchat>',`${localData[index].internalChat?'Chat':'No chat'}`)
            }else if(f.includes('<whatsapp>')){
              return f.replace('<whatsapp>',`${localData[index]?.postCallSms?'Post Call':'No post call'}`)
            }else if(f.includes('<training>')){
              return f.replace('<training>',`${localData[index].agentTraining?'Training':'No training'}`)
            }else{
              return f
            }
            
          })
          finalPlans.push({
            ...obj,
            amount:localData[index]?.pricePoint??obj.amount,
            planType:localData[index]?.planType??"STANDARD",
            plan:localData[index]?.planName??obj.plan,
            userslimit:localuserslimit,
            features:localfeatures
          })
        })
        console.log('Final Plans >>>>>>> ',finalPlans)
        setPlanList(finalPlans);
    }).catch(error => {
      console.log('Error Plans >>>>>>> ',prepaidPackages)
      setPlanList([...prepaidPackages]);
    })
  }

  useEffect(()=>{
    getPrepaidPlans()
  },[])
  return (
    <>
      <Header page="subscription" />
      <div className={classnames(classes.container, "minheightCont100vh")}>
        <div className={classes.tabSection}>
          <div className={classes.headingtab}>
            We got a plan that's perfect for you!
          </div>
          <div className={classes.tabs}>
            <div
              className={classnames(
                classes.tabcls,
                tab === "prepaid" && classes.selected
              )}
              onClick={() => setTab("prepaid")}
            >
              Prepaid packages
            </div>
            <div
              className={classnames(
                classes.tabcls,
                tab === "custom" && classes.selected
              )}
              onClick={() => setTab("custom")}
            >
              Custom solution
            </div>
          </div>
          <div className={classes.cards}>
            {tab === "prepaid" ? (
              planList.map(p => {
                return <PackageCard key={p.plan} {...p} />;
              })
            ) : (
              <CustomEnterprisePlan />
            )}
          </div>
        </div>
        <StandardFeatures />
      </div>
      <Footer />
    </>
  );
}
export default SubscriptionPage;
